import React from 'react';
import styled from 'styled-components/macro';
import { rgba } from 'polished';
import { connect } from 'react-redux';
import { fetchSideNav } from '../actions';

function CardGridContainer({ type, isSideNavToggled, children }) {
  return (
    <Container
      type={type}
      navClosed={!isSideNavToggled}
      navOpen={isSideNavToggled}
    >
      {children}
    </Container>
  );
}

const Container = styled.section`
  clear: both;
  margin-left: auto;
  margin-right: auto;
  padding: 0;
  position: relative;
  z-index: 10;

  ${(props) =>
    props.navOpen &&
    `
    @media screen and (min-width: 768px) {
      margin-left: 96px;
    }
    @media screen and (min-width: 1024px) {
      margin-left: 324px;
    }
    body.non-touch {
      overflow: hidden;
      @media screen and (min-width: 768px) {
        overflow: auto;
      }
    }
  `};
  ${(props) =>
    props.navClosed &&
    `
    @media screen and (min-width: 768px) {
      margin-left: 96px;
    }
    @media screen and (min-width: 1024px) {
      margin-left: 96px;
    }
  `};
  ${(props) =>
    props.type === 'az-quick' &&
    `
    box-shadow: inset 0 1px 0 0
      ${
        props.theme.name === 'light'
          ? rgba(props.theme.color.blackFull, 0.25)
          : props.theme.color.white10
      };
    @media screen and (min-width: 768px) {
      padding-top: 24px !important;
    }
  `};

  ${(props) =>
    props.type === 'footer' &&
    `
    form {
      margin: 0 10px;
      width: calc(100% - 20px);
      max-width: 100%;
      @media screen and (min-width: 768px) {
        margin: 0;
        max-width: 375px;
      }
    }
    &:after {
      display: block;
      width: 100%;
      height: 1px;
      margin: 30px 0 10px;
      box-shadow: inset 0 1px 0 0 ${
        props.theme.name === 'light'
          ? rgba(props.theme.color.blackFull, 0.25)
          : props.theme.color.white10
      };
      content: '';
      @media screen and (min-width: 768px) {
        margin-top: 46px;
      }
    }
    @media screen and (min-width: 1920px) {
      margin-top: 64px;
    }
  `};
`;

function mapStateToProps(state) {
  return {
    isSideNavToggled: state.sideNav,
  };
}

export default connect(mapStateToProps, { fetchSideNav })(CardGridContainer);
